import { Observable } from 'rxjs';

import type {
  DepositPlanAlt,
  DepositPlansAlt,
  NewDepositAssetsPlan,
  DepositPlanDto,
  DepositAssetDto
} from '@coin-depo-types';

export interface DepositAssetsFacade {
  cachedDepositPlans$: Observable<DepositPlanDto[]>;
  cachedDepositPlansAlt$: Observable<DepositPlanAlt[]>;
  cachedDepositPlansSelect$: Observable<DepositPlanDto[]>;
  cachedDepositDropdown$: Observable<NewDepositAssetsPlan[]>;

  getDepositAssets(id: number): Observable<DepositAssetDto[]>;

  updateNewDepositDropdown(): Observable<NewDepositAssetsPlan[]>;

  getDepositDropdownById(
    id: string | number
  ): Observable<NewDepositAssetsPlan[]>;

  getSnapshotDepositDropdownById(
    id: string | number
  ): NewDepositAssetsPlan[];

  updateDepositPlans(): Observable<DepositPlanDto[] | string>;

  updateDepositPlansAlt(): Observable<DepositPlansAlt>;

  getDepositPlansAltSnapshot(): DepositPlanAlt[];
}